package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.toggle.EsTab
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme

@Composable
fun ProposalTabs(
    tabItems : List<TabState>,
    selectedTabIndex: Int,
    setSelectedTabIndex: (Int) -> Unit,
) {
    Row(
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        EsTab(
            items = tabItems,
            tabWidth = 120.dp,
            selectedItemIndex = selectedTabIndex,
            onClick = { tabState ->
                setSelectedTabIndex(tabState.index)
            },
        )
    }
}